import React from 'react';
import { useRef } from 'react';

const width = 120;
const height = 60;
const meterWidth = 4;
const gap = 2;
const capHeight = 2;
const increment = 2;
const capStyle = '#40ACC2';

function YunSpectrum(props) {
    const {  data = [], } = props;
    const timer = useRef(null);
    const cavasRef = useRef(null);
    const animationId = useRef();
    const status = useRef(0);
    const cacheData = useRef([]);
    const dataAry = useRef([]);
    // console.log(data);
    const transition = (startAry, targetAry, increment) => {
        const result = []
        for (let i = 0; i < targetAry.length; i++) {
            const s = startAry[i] || 0;
            if (s >= targetAry[i]) {
                targetAry[i] = 0
            }
            let r = s >= targetAry[i] ? (s - increment) : (s + increment);
            result.push(r);
        }
        return result;
    }

    const animation = () => {
        if (animationId.current) {
            cancelAnimationFrame(animationId.current);
            animationId.current = null;
        }
        const ctx = cavasRef.current.getContext('2d');
        const meterNum = width / (meterWidth + gap);

        const gradient = ctx.createLinearGradient(0, 0, 0, height);
        gradient.addColorStop(0, '#ffffff');
        gradient.addColorStop(0.5, '#ffffff90');
        gradient.addColorStop(1, '#ffffff20');
        const capYPositionArray = [];
        const drawMeter = () => {
            const array = transition(cacheData.current, dataAry.current, increment);
            cacheData.current = array.slice();
            if (status.current === 0) {
                // for (let i = array.length - 1; i >= 0; i--) {
                //     array[i] = 0;
                // };
                const allCapsReachBottom = !capYPositionArray.some(cap => cap >= 0);
                if (allCapsReachBottom) {
                    ctx.clearRect(0, 0, width, height);
                    cancelAnimationFrame(animationId.current);
                    return
                }
            };            
            const step = parseInt((array.length / meterNum), 10) || 1;
            ctx.clearRect(0, 0, width, height);
            const meterGapWidth = meterWidth + gap;
            
            for (let i = 0; i < meterNum; i++) {
                const value = array[i * step];
                if (capYPositionArray.length < Math.round(meterNum)) {
                    capYPositionArray.push(value);
                };
                ctx.fillStyle = capStyle;
                if (value < capYPositionArray[i]) {
                    ctx.fillRect(i * meterGapWidth, height - (--capYPositionArray[i]), meterWidth, capHeight);
                } else {
                    ctx.fillRect(i * meterGapWidth, height - value, meterWidth, capHeight);
                    capYPositionArray[i] = value;
                };
                ctx.fillStyle = gradient;
                ctx.fillRect(i * meterGapWidth, height - value, meterWidth, height - capHeight);
            }
            animationId.current = requestAnimationFrame(drawMeter);
        }
        animationId.current = requestAnimationFrame(drawMeter);
    }
    if (data.length && cavasRef.current) {
        if (timer.current) {
            clearTimeout(timer.current);
        }
        if (status.current === 0) {
            animation()
        }
        status.current = 1;
        dataAry.current = data.slice();
        timer.current = setTimeout(() => {
            status.current = 0;
        }, 1000)
    } else {
        status.current = 0;
        dataAry.current = [];
        if (animationId.current) {
            cancelAnimationFrame(animationId.current);
            animationId.current = null;
        }
    }

    return (
        <canvas ref={cavasRef} width={width} height={height}></canvas>
    )
}

export default YunSpectrum;
